import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import CompanyDashboard from "../companies/CompanyDashboard";
import ExpiredCertifications from './ExpiredCertifications';
import AuditSurvellianceReport from './AuditSurvellianceReport';
import RenewalStatusReport from './RenewalStatusReport';
const ReportPage = () => {

    const navigate = useNavigate();

    const items = [
    {
      label: "Expired Certifications",
      key: "expiredcertifications",
    },
    {
      label: "Audits Surveillance",
      key: "auditssurveillance",
    },
    {
      label: "Renewal Status",
      key: "renewalstatus",
    },
  ];

   const [current, setCurrent] = useState("expiredcertifications");
  
    const onClick = (e) => {
      setCurrent(e.key);
    };

  return (
    <div>
        <CompanyDashboard/>
      <div className="settings-access-container mt-3">
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={items}
          className="settings-access-menu"
        />
        <div className="tab-content">
          {current === "expiredcertifications" && < ExpiredCertifications/>}
          {current === "auditssurveillance" && < AuditSurvellianceReport/>}
          {current === "renewalstatus" &&  <RenewalStatusReport/>}
        </div>
      </div>
    </div>
  )
}

export default ReportPage
